import * as React from "react";
const SvgEdit = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.338 3.152a.56.56 0 0 1 .79 0l3.72 3.72a.558.558 0 1 1-.789.79l-3.721-3.721a.56.56 0 0 1 0-.79",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.68 2.389-9.857 9.856-.586 3.518 3.518-.586 9.856-9.857a.93.93 0 0 0 0-1.315l-1.616-1.616a.93.93 0 0 0-1.315 0m-.79-.79a2.046 2.046 0 0 1 2.894 0l1.617 1.617a2.047 2.047 0 0 1 0 2.894l-9.983 9.982a.56.56 0 0 1-.303.156l-4.465.744a.558.558 0 0 1-.642-.642l.744-4.465a.56.56 0 0 1 .156-.303z",
    clipRule: "evenodd"
  }
));
export default SvgEdit;
